import './ProductDiscountBadge.less';

export type ProductDiscountBadgeProps = {
    mode: 'text' | 'percentage';
    className?: string;
    text?: string;
    percentage?: number;
    digits?: number;
};

const ProductDiscountBadge = ({
    mode,
    className = '',
    percentage,
    digits = 0,
    text
}: ProductDiscountBadgeProps) => {
    if (!percentage) {
        return null;
    }

    switch (mode) {
        case 'percentage':
            return (
                <span className={`bri-ProductDiscountBadge ${className}`}>
                    {Number(-percentage / 100).toLocaleString(undefined, {
                        style: 'percent',
                        minimumFractionDigits: digits
                    })}
                </span>
            );
        case 'text':
            return (
                <span className={`bri-ProductDiscountBadge ${className}`}>
                    {text}
                </span>
            );
        default:
            return null;
    }
};

export default ProductDiscountBadge;
